import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: auto;
    height: auto;
    padding: 5px 8px;

    gap: 0.25rem;
    display: flex;
    align-items: center;

    border-radius: 10rem;
    background-color: ${props => props.bgcolor ? props.bgcolor : theme.colors.gray.Cinza_2};
    cursor: ${props => props.clickable ? 'pointer' : 'default'};

    >img{
        width: 16px;
        height: auto;
    }
`;
